// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"35dc4db3","484":"f88507f8","628":"8f7a6236","850":"b241f526"}[chunkId] + ".chunk.css";
};